import React, { forwardRef, useEffect } from "react";
import { useCallback } from "react";
import { useRef } from "react";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import lang from "../../classes/lang";
import Form from "../../components/form/Form";
// import { useSlotTemplate } from "./useBattle";
import Axios from "../../classes/axios";
import { onResult, closeModal } from "../../classes/utills";
import toast from "../../classes/toast";
import useGames from "../flappyBet/useGames";
import CheckBox from "../../components/checkBox/CheckBox";

// import PropTypes from "prop-types";
//containers:
// import Container from "../Container";

// eslint-disable-next-line no-unused-vars
const BattleCreate = forwardRef((props, ref) => {
	BattleCreate.propTypes = {
		// uid: PropTypes.any.isRequired,
	};
	const [loading, setLoading] = useState(false);
	const frmRef = useRef();
	const [amountUsd, setAmountUsd] = useState();
	const [participants, setParticipants] = useState(5);
	const [waitMs, setWaitMs] = useState(60000 * 3);
	const [templateId, setTemplateId] = useState();
	const [gamePattern, setGamePattern] = useState();
	const [pay, setPay] = useState(false);
	const [invisible, setInvisible] = useState(false);
	const [onlyrefallowed, setOnlyrefallowed] = useState(false);
	// const { templates } = useSlotTemplate({ amountUsd });
	const flappyGames = useSelector((s) => s.flappyGames ?? []).filter((el) => el.HasFreespins);
	const { getGames } = useGames({ coinSelected: "usdt" });
	useEffect(() => {
		getGames();
	}, []);
	const short = useSelector((s) => s.coin?.selected);
	const frmData = useMemo(() => {
		const arr = [];
		arr.push({
			type: "select",
			label: lang.translate("amount") + "$",
			name: "amountUsd",
			value: amountUsd,
			data: [0.05, 0.1, 0.2, 1, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 50, 100].map((el) => ({
				id: `${el}`,
				value: el,
				title: `${el}`,
			})),
			onSelect: (item) => {
				setAmountUsd(item.value);
				setTemplateId();
			},
		});
		arr.push({
			type: "select",
			label: lang.translate("participants"),
			name: "participants",
			value: participants,
			data: [2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 30, 40, 50, 100, 200, 500, 1000].map((el) => ({
				id: `${el}`,
				value: el,
				title: `${el}`,
			})),
			onSelect: (item) => {
				setParticipants(item.value);
			},
		});
		arr.push({
			type: "select",
			label: lang.translate("waiting_time"),
			name: "waitMs",
			value: waitMs,
			data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 30]
				.map((min) => {
					const ms = min * 60000;
					return {
						id: `${ms}`,
						value: ms,
						title: `${min} ${lang.translate("min")}`,
					};
				})
				.concat(
					[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 24, 48].map((h) => {
						const ms = h * 60 * 60000;
						return {
							id: `${ms}`,
							value: ms,
							title: `${h} ${lang.translate("h")}`,
						};
					}),
				),
			onSelect: (item) => {
				setWaitMs(item.value);
			},
		});
		arr.push({
			type: "select",
			label: lang.translate("game"),
			name: "templateId",
			className: "gameSelect",
			value: templateId,
			data: (flappyGames ?? [])
				.filter((el) => el.Name.toLowerCase().includes(gamePattern))
				.map((el) => ({
					id: `${el.Id}`,
					value: el.Id,
					title: `${el.Name}`,
					c: <img src={el.Image} alt="" />,
				})),
			onSearch: (pattern) => {
				setGamePattern(`${pattern ?? ""}`.toLowerCase());
			},
			onSelect: (item) => {
				setTemplateId(item.value);
			},
		});
		arr.push({
			type: "component",
			name: "pay",
			value: (
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
					<CheckBox
						style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}
						checked={pay}
						title={`${lang.translate("free_battle")}:`}
						onToggle={() => {
							setPay(() => !pay);
							if (!pay) setOnlyrefallowed(false);
						}}
					/>
				</div>
			),
		});
		arr.push({
			type: "component",
			name: "invisible",
			value: (
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
					<CheckBox
						style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}
						checked={invisible == true}
						title={`${lang.translate("private")}:`}
						onToggle={() => {
							setInvisible(() => !invisible);
						}}
					/>
				</div>
			),
		});
		arr.push({
			type: "component",
			name: "onlyrefallowed",
			value: (
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
					<CheckBox
						disabled={pay === false}
						style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", opacity: pay === false ? 0.3 : 1 }}
						checked={pay === true && onlyrefallowed}
						title={`${lang.translate("only_ref_allowed")}:`}
						onToggle={() => {
							setOnlyrefallowed(() => !onlyrefallowed);
						}}
					/>
				</div>
			),
		});
		{
			arr.push({
				type: "component",
				name: "payTotal",
				value: (
					<div
						style={{
							color: "gold",
							fontWeight: "bold",
							fontSize: "18px",
							padding: "5px",
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<b>{lang.translate("total_amount")}:</b>
						<b>{(isNaN((pay ? participants : 1) * amountUsd) ? 0 : (pay ? participants : 1) * amountUsd).toFixed(2)}$</b>
					</div>
				),
			});
		}
		return arr;
	}, [amountUsd, participants, waitMs, templateId, gamePattern, pay, invisible, onlyrefallowed]);

	const onCreate = useCallback(async () => {
		if (loading) return;
		const { amountUsd, participants, templateId, waitMs } = frmRef.current.getValues();
		if (typeof templateId === "undefined") return;
		setLoading(true);
		const o = { short, amountUsd, maxParticipants: participants, templateId, waitMs, pay, invisible, onlyrefallowed: pay === true && onlyrefallowed };
		const result = await Axios.post("api/battle/create", o);
		await onResult(result, "unexpected_error", () => {
			toast.success(lang.translate("battle_created"));
			closeModal();
		});
		setLoading(false);
	}, [short, loading, pay, invisible, onlyrefallowed]);

	return (
		<div className="BattleCreate">
			<h2>{lang.translate("create_new_battle")}</h2>
			{Array.isArray(frmData) && (
				<Form
					key={`frm_${amountUsd}`}
					ref={frmRef}
					className="frmBattleCreate"
					data={frmData}
					buttons={[
						{
							img: "/assets/icons2/svg/battle.svg",
							label: "create",
							disabled: !templateId,
							className: "diceBtn green",
							onClick: onCreate,
						},
					]}
				/>
			)}
		</div>
	);
});
BattleCreate.displayName = "BattleCreate";
export default BattleCreate;
